/*

  i n d e x
  Index

  :description:
  Our central file for providing names for things that are exported from this package.

  Caution! This file should not contain actual functions/logic.

*/

//
//  :imports:
import {
  ENUM_MODES as modes,
  ENUM_MODE_MOBILE as modeMobile,
  ENUM_MODE_DESKTOP as modeDesktop,
  ENUM_PLATFORMS as platforms,
  ENUM_PLATFORM_ANDROID as platformAndroid,
  ENUM_PLATFORM_IOS as platformiOS,
  ENUM_PLATFORM_WINDOWS as platformWindows,
  ENUM_PLATFORM_LINUX as platformLinux,
} from "./statics";
import { Environment as envClass } from "./environment";

//
//  :exports:
export const Environment = envClass;
export const ENUM_MODES = modes;
export const ENUM_MODE_MOBILE = modeMobile;
export const ENUM_MODE_DESKTOP = modeDesktop;
export const ENUM_PLATFORMS = platforms;
export const ENUM_PLATFORM_ANDROID = platformAndroid;
export const ENUM_PLATFORM_IOS = platformiOS;
export const ENUM_PLATFORM_WINDOWS = platformWindows;
export const ENUM_PLATFORM_LINUX = platformLinux;

//
//  :window-exports:
if (window) {
  window.ekyEnvironmentClass = envClass
}
